import { Box, Circle, Text, colors } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface TitleProps {
  label: string
  showTotal: boolean
  showDivider: boolean
  showLaborCost: boolean
  showAgreementData: boolean
  showEmployeeExpenses: boolean
}

const Titles = ({
  label,
  showTotal,
  showDivider,
  showLaborCost,
  showAgreementData,
  showEmployeeExpenses,
}: TitleProps) => {
  return (
    <Box flexDirection="column" gap="s8">
      <Box flexDirection="row" gap="s8" alignItems="flexStart">
        <Text.Normal size="300" weight="bold" color="grey1000">
          {label}
        </Text.Normal>
      </Box>
      {showAgreementData && (
        <Box flexDirection="row" gap="s8" alignItems="center" minHeight="s24">
          <Box
            height="s2"
            width="s12"
            flexDirection="row"
            style={{ backgroundColor: colors.grey800 }}
          />
          <Text.Normal size="200">
            {i18n.t('finance.financial_workspace.employee_costs.totals.agreement.label')}
          </Text.Normal>
        </Box>
      )}
      {showDivider && <Box background="grey200" width="full" height="s2" />}
      {showEmployeeExpenses && (
        <Box flexDirection="row" gap="s8" alignItems="center" minHeight="s24">
          <Circle color={colors.moodNeutral} size={12} />
          <Text.Normal size="200">
            {i18n.t('finance.financial_workspace.employee_costs.totals.expenses.label')}
          </Text.Normal>
        </Box>
      )}
      {showLaborCost && (
        <Box flexDirection="row" gap="s8" alignItems="center" minHeight="s24">
          <Circle color="#5596F6" size={12} />
          <Text.Normal size="200">
            {i18n.t('finance.financial_workspace.employee_costs.totals.payroll.label')}
          </Text.Normal>
        </Box>
      )}
      {showTotal && (
        <Box flexDirection="row" gap="s8" alignItems="center" minHeight="s24">
          <Box flexDirection="row" width="s12" />
          <Text.Normal weight="medium" size="200">
            {i18n.t('finance.financial_workspace.employee_costs.totals.total.label')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export { Titles }
